module.exports = __webpack_public_path__ + "static/media/018yhkgl.92eceb51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/018yhkgl.jpg
// module id = 636
// module chunks = 0 1